<template>
  <div class="lifecare-modal">
    <c-alert is-close-btn @close="onConfirm">
      <template #content>
        <div class="modal-content">
          <div class="message">
            <span class="message-title">신청이 완료됐어요</span>
            <p class="message-sub">
              카카오톡 메시지로 안내사항을 먼저 보내드렸어요.<br />
              <template v-if="nightCallbackTime"
                >대표번호 {{ TEL_LIFECARE }}로<br />{{ nightCallbackTime }} 전화드릴게요.</template
              >
              <template v-else>대표번호({{ TEL_LIFECARE }})로<br />전화드릴게요.</template>
            </p>
          </div>
          <div class="buttons">
            <c-button
              :size="CButtonSize.L"
              :type="CButtonType.Fill"
              :variant="CButtonVariant.Primary"
              label="확인"
              @click="onConfirm"
            />
          </div>
        </div>
      </template>
    </c-alert>
  </div>
</template>

<script setup lang="ts">
import { CAlert, CButton, CButtonSize, CButtonType, CButtonVariant } from '@aj-fe/aj-vue-core'

// 상조(메인 없음) 완료 안내 대표번호 — 메인 카테고리(1833-3504)와 다름
const TEL_LIFECARE = '1833-7377'

withDefaults(defineProps<{ nightCallbackTime?: string | null }>(), {
  nightCallbackTime: null,
})

const emit = defineEmits<{
  (e: 'confirm'): void
}>()

const onConfirm = () => emit('confirm')
</script>

<style lang="scss">
@use '@aj-fe/aj-vue-core/styles/theme' as theme;
@use './modal-shared' as shared;

.lifecare-modal {
  @include shared.alert-card;

  .c-alert-container .modal-content {
    .message {
      text-align: center;

      .message-title {
        display: block;
        @include theme.Heading-S;
        color: var(--c-gray900, #1f2429);

        @media (max-width: 1024px) {
          @include theme.Heading-XS;
        }
      }

      .message-sub {
        margin-top: 12px;
        @include theme.Body-S-400;
        color: var(--c-gray700, #575e64);

        @media (max-width: 1024px) {
          @include theme.Body-XS-400;
        }
      }
    }

    .buttons {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  }
}
</style>
